// extracted by mini-css-extract-plugin
module.exports = {"content":"Fitting_content__1cs4c","submitBtn":"Fitting_submitBtn__7f-Ce"};